module.exports = __webpack_public_path__ + "img/literature.39997196.png";